// 2020-10-27
export { AvatarPhotoComponent } from './avatar-photo.component';
